export default "__VITE_ASSET__tmgnD6fA__"